import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useContext, useState } from 'react';
export var DialogExpansionContext = /*#__PURE__*/React.createContext({
  isExpanded: false,
  setIsExpanded: function setIsExpanded(isExpanded) {},
  allowChangeExpand: function allowChangeExpand(expand) {}
});
export var DialogExpansionContextProvider = function DialogExpansionContextProvider(_ref) {
  var children = _ref.children,
    isExpanded = _ref.isExpanded,
    setIsExpanded = _ref.setIsExpanded;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    changeExpand = _useState2[0],
    setChangeExpand = _useState2[1];
  return /*#__PURE__*/React.createElement(DialogExpansionContext.Provider, {
    value: {
      isExpanded: isExpanded,
      setIsExpanded: changeExpand ? setIsExpanded : function () {},
      allowChangeExpand: setChangeExpand
    }
  }, children);
};
export var useDialogExpansionContext = function useDialogExpansionContext() {
  return useContext(DialogExpansionContext);
};
export var withDialogExpansionContext = function withDialogExpansionContext(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, useDialogExpansionContext()));
  };
};